var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 172,
    viewBox: "0 0 149 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.39 97.002C148.39 107.992 145.99 118.432 141.68 127.812C130 153.302 104.26 171.002 74.3896 171.002C44.5196 171.002 18.7796 153.302 7.09965 127.812C2.78965 118.432 0.389648 107.992 0.389648 97.002C0.389648 56.132 33.5196 23.002 74.3896 23.002C115.26 23.002 148.39 56.132 148.39 97.002Z",
    fill: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12817_297066",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 149,
    height: 171
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 40.5C148.5 51.49 146.1 118.43 141.79 127.81C130.11 153.3 104.37 171 74.5 171C44.63 171 18.89 153.3 7.21 127.81C2.9 118.43 0.5 51.49 0.5 40.5C0.5 -0.369999 33.63 0.000117124 74.5 0.000117124C115.37 0.000117124 148.5 -0.369999 148.5 40.5Z",
    fill: "#F0F1F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12817_297066)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12817_297066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3926 19.623C18.3926 18.726 19.1186 18 20.0156 18H128.77C129.667 18 130.393 18.726 130.393 19.623V169.826C130.393 170.723 129.667 171.449 128.77 171.449H20.0156C19.1186 171.449 18.3926 170.723 18.3926 169.826V19.623Z",
    fill: "#5BA7B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.393 75.2754H18.3926V105.71H130.393V75.2754Z",
    fill: "#7FBEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3926 105.711H130.393V169.827C130.393 170.724 129.667 171.45 128.77 171.45H20.0156C19.1186 171.45 18.3926 170.724 18.3926 169.827V105.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4867 75.1287H40.5017L38.4727 63.0117H42.4497L42.6287 64.0827L44.4867 75.1287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.241 105.85H103.7L101.295 91.5117H104.835L107.241 105.85Z",
    fill: "#6D493C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9862 59.8264H41.9172L36.8672 29.7344H65.6902C66.9872 29.7344 68.0942 30.6714 68.3092 31.9504L72.9862 59.8264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9175 59.8274H37.9375L33.4075 32.8294C33.1355 31.2104 34.3835 29.7344 36.0255 29.7344H36.8675L41.9175 59.8274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.182 63.0302L101.643 72.4852L102.085 75.1262H93.7297L108.512 63.0122H86.7207V59.8262H113.182V63.0302Z",
    fill: "#6D493C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2053 94.1507L60.9273 105.85H56.2363L73.7323 91.5117H74.7603L75.2053 94.1507Z",
    fill: "#6D493C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5492 69.1407L71.4371 71.6917L67.2462 75.1257H44.4841L42.4521 63.0117H73.5201L74.5492 69.1407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7199 63.0132L75.1169 72.5222L80.7089 105.85H77.1689L72.0139 75.1262L72.0049 75.0712L71.9379 75.1262L34.4449 105.85H29.7539L82.0289 63.0122H33.1729V59.8262H86.7199V63.0132Z",
    fill: "#AF5947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.179 77.7849V91.5149H88.9932V75.1289H115.524C116.99 75.1289 118.179 76.3179 118.179 77.7849Z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9937 75.1289V91.5139H78.3027L75.5537 75.1289H88.9937Z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7614 91.5152H51.9424L72.0034 75.0742L74.7614 91.5152Z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2439 75.1289L47.23 91.5149H43.253L40.502 75.1289H67.2439Z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3926 117H31.3926C30.2876 117 29.3926 117.895 29.3926 119C29.3926 120.105 30.2876 121 31.3926 121H77.3926C78.4976 121 79.3926 120.105 79.3926 119C79.3926 117.895 78.4966 117 77.3926 117Z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3926 132H34.3926C31.6316 132 29.3926 134.239 29.3926 137C29.3926 139.761 31.6316 142 34.3926 142H64.3926C67.1536 142 69.3926 139.761 69.3926 137C69.3926 134.239 67.1536 132 64.3926 132Z",
    fill: "#CE375C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12817_297066",
    x: 8.39258,
    y: 10,
    width: 132,
    height: 173.449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12817_297066"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12817_297066",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.883a888f878c5efd5fb66123dbc57dbd.svg";
export { ForwardRef as ReactComponent };